export default __webpack_public_path__ + "static/media/home.a0bda126.png";